<template>
  <div class="ga-4 mb-8 fade-in">
    <h1 class="text-h2 text-center mb-6 font-weight-bold fade-in">
      Welcome to Elite Glazing Solutions LLC
    </h1>
    <p class="text-center text-muted fade-in">
      Your trusted partner for premium window and glass installations in the Denver metro area.
    </p>
    <hr
      class="w-80 bg-secondary my-4 fade-in"
      style="height: 5px"
    />
    <h2 class="my-4 fade-in">Our Expertise in Glazing Solutions</h2>
    <p class="fade-in">
      At Elite Glazing Solutions, we specialize in transforming spaces with precision-crafted glazing services tailored to meet your unique needs. Whether you're upgrading your home with energy-efficient windows, adding elegant glass partitions to your office, or installing custom storefront glass, we bring expertise and dedication to every project.
    </p>
    <h2 class="my-4 fade-in">Why Choose Elite Glazing Solutions?</h2>
    <p class="fade-in">
      With years of experience and a commitment to excellence, we pride ourselves on delivering outstanding results and exceptional customer service. Our team ensures each installation is performed with meticulous care, using high-quality materials designed for durability and aesthetic appeal. We focus on energy efficiency, safety, and innovative designs to enhance both residential and commercial spaces.
    </p>
    <h2 class="my-4 fade-in">Our Services</h2>
    <ul class="fade-in">
      <li>Residential Window Installation & Replacement</li>
      <li>Commercial Storefront Glazing</li>
      <li>Custom Glass Partitions & Doors</li>
      <li>Energy-Efficient & Low-E Glass Solutions</li>
      <li>Skylights, Mirrors, & Decorative Glass</li>
      <li>Glass Repair & Maintenance Services</li>
    </ul>
    <h2 class="my-4 fade-in">Serving the Denver Metro Area</h2>
    <p class="fade-in">
      Based in Denver, we proudly serve homeowners and businesses throughout the metro area. No matter the scale of your project, our glazing specialists ensure top-tier craftsmanship with a focus on longevity and efficiency.
    </p>
    <div class="d-flex justify-center align-center fade-in">
      <CTA actionButtonText="Get a Free Quote Today" to="#contact-form" class="mt-4" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';

onMounted(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    },
    { threshold: 0.1 } // Trigger when 10% of the element is visible
  );

  const fadeElements = document.querySelectorAll('.fade-in');
  fadeElements.forEach((el) => observer.observe(el));
});
</script>

<style>
.fade-in {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.fade-in.visible {
  opacity: 1;
  transform: translateY(0);
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
  color: var(--v-theme-primary)!important;
}
</style>